module.exports = __webpack_public_path__ + "img/img_right.29741227.jpg";